export default "__VITE_ASSET__BLu0fp3r__"